import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';

import { TaraHeader } from '../../Tara';
import { personaOptions } from '../../Tara/TaraQuestionPersona';

const personaLabels = {};

personaOptions.forEach((persona) => {
  personaLabels[persona.value] = persona.label.toLowerCase();
});

const getQuantity = (quantity) => {
  if (!quantity) {
    return 'any';
  }

  switch (quantity) {
    case 4:
      return '4+';
    default:
      return quantity;
  }
};

const Container = glamorous.div(props => ({
  cursor: 'pointer',
  userSelect: 'none',
  padding: 8,
  backgroundColor: '#fff',
  borderTop: `1px solid ${props.theme.default.lightest}`,
  ...props.glamStyle,
}));

const TAKING_TIME_DELAY = 6000;

class TaraFiltersBlock extends React.PureComponent {
  static propTypes = {
    message: PropTypes.node,
  };

  static defaultProps = {
    message: undefined,
  };

  state = {
    isTakingTime: false,
  };

  componentDidMount() {
    this.hasMounted = true;
  }

  componentWillUnmount() {
    this.hasMounted = false;
  }

  componentWillReceiveProps(nextProps) {
    const { isFetching } = nextProps;

    if (isFetching !== this.props.isFetching) {
      this.setIsTakingTime(isFetching);
    }
  }

  setIsTakingTime = (isTakingTime) => {
    if (isTakingTime) {
      setTimeout(() => {
        if (this.hasMounted && this.props.isFetching) {
          this.setState({ isTakingTime: true });
        }
      }, TAKING_TIME_DELAY);
    } else {
      this.setState({ isTakingTime: false });
    }
  };

  get taraMessage() {
    const {
      ticketList,
      quantity,
      persona,
      hasNoRecommendedTickets,
      shouldShowAllTickets,
      eventName,
      venue,
    } = this.props;

    const { length } = ticketList;

    if (this.props.isFetching || this.props.mapStatus === 'LOADING') {
      if (this.state.isTakingTime) {
        return (
          <div>Nearly done &hellip;</div>
        );
      }

      return (
        <div>One moment while I find your ideal tickets!</div>
      );
    }

    const numOfTickets = (
      <div>
        <span>{length === 1 ? 'There is ' : 'There are '}</span>
        <strong>{length} </strong>
        <span>{length === 1 ? 'ticket' : 'tickets'} for </span>
        <strong>{eventName}!</strong>
      </div>
    );

    if (hasNoRecommendedTickets) {
      return (
        <div>
          <div>Sorry, I&apos;m still learning about <strong>{venue}!</strong></div>
          {numOfTickets}
        </div>
      );
    }

    if (shouldShowAllTickets) {
      return (
        <div>
          {numOfTickets}
          <div>
            <span>Check them out or </span>
            <strong>find your right tickets.</strong>
          </div>
        </div>
      );
    }

    return (
      <div>
        <div>
          <span>I have found </span>
          <strong>{length} </strong>
          <span>{length === 1 ? 'perfect option' : 'great options'} for </span>
          <strong>{getQuantity(quantity)} </strong>
          <span>{quantity === 1 ? 'seat' : 'seats'} for </span>
          <strong>{personaLabels[persona]} </strong>
          <span>for </span>
          <strong>{eventName}!</strong>
        </div>
        <div>
          <span>Check them out or </span>
          <strong>browse all tickets.</strong>
        </div>
      </div>
    )
  }

  render() {
    return (
      <Container
        onClick={this.props.onClick}
        glamStyle={this.props.style}
      >
        <TaraHeader
          isAnimated
          message={this.taraMessage}
        />
      </Container>
    );
  }
}

export default TaraFiltersBlock;



// WEBPACK FOOTER //
// ./src/components/features/SeaticsMapWidget/Sidebar/TaraFiltersBlock.js